module.exports = __webpack_public_path__ + "static/fonts/DINProMedium.28ac1a6b.woff";